import { render, staticRenderFns } from "./FormItemLabel.vue?vue&type=template&id=5a7f7cd3&scoped=true"
import script from "./FormItemLabel.vue?vue&type=script&lang=ts"
export * from "./FormItemLabel.vue?vue&type=script&lang=ts"
import style0 from "./FormItemLabel.vue?vue&type=style&index=0&id=5a7f7cd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7f7cd3",
  null
  
)

export default component.exports